'use client';

import { Dispatch, SetStateAction, useMemo } from 'react';
import { cn } from '@/helpers/common';
import IconKebab from '@/components/svgs/icons/kebab-icon';

import { ROUTES } from '@/constants/routes/default';
import { signOut } from 'next-auth/react';
import Dropdown from '../Dropdowns/Dropdown';

const HeaderDropdownKD = ({ session, isSighInPath }: { session: any; isSighInPath?: boolean }) => {
  const options = useMemo(() => {
    let result = [];

    if (session) {
      result = [
        { type: 'link', title: 'All Jobs', href: ROUTES.jobs, withDivider: true },
        {
          type: 'link',
          title: 'My search',
          href: ROUTES.profile,
          withDivider: false,
        },
        { type: 'link', title: 'For employers', href: ROUTES.partners, withDivider: false },
        {
          type: 'button',
          title: 'Sign Out',
          onClick: () => signOut(),
          withDivider: true,
        },
      ];
    } else {
      result = [
        {
          type: 'link',
          title: 'All Jobs',
          href: ROUTES.jobs,
          withDivider: !!session,
        },
        { type: 'link', title: 'For employers', href: ROUTES.partners, withDivider: false },
        {
          type: 'link',
          title: isSighInPath ? 'Sign Up' : 'Sign In',
          href: ROUTES[isSighInPath ? 'signup' : 'signin'],
          withDivider: false,
        },
      ];
    }

    return result;
  }, [session, isSighInPath]);

  return (
    <Dropdown
      rootCn={''}
      listCn={'max-w-50 right-0 bg-white py-2 custom-shadow-kd rounded-xl'}
      elementCn={'text-sm h-9 px-4 flex items-center hover:bg-kd-athens-gray'}
      dividerCn={'border-kd-geyser'}
      listHeader={
        session && session?.user?.email ? (
          <div
            className={cn(
              'px-4 text-xs text-kd-mako overflow-hidden truncate whitespace-nowrap text-ellipsis',
            )}
          >
            {session?.user?.email}
          </div>
        ) : null
      }
      options={options}
    >
      {({
        setIsOpen,
        isOpen,
        listId,
      }: {
        setIsOpen: Dispatch<SetStateAction<boolean>>;
        isOpen: boolean;
        listId: string;
      }) => (
        <button
          aria-label="Menu"
          aria-expanded={isOpen}
          aria-controls={isOpen ? listId : undefined}
          onClick={() => {
            setIsOpen((prev) => !prev);
          }}
          className={cn(
            'flex items-center justify-center relative py-3 px-2.5 [&>svg>path]:fill-white! no-underline default-transition rounded-xl bg-kd-persimmon hover:bg-kd-valencia',
            isOpen && 'bg-kd-valencia',
          )}
        >
          <IconKebab
            aria-hidden="true"
            className="shrink-0 [&>rect]:fill-current [&>rect]:transition-all [&>rect]:duration-300"
          />
        </button>
      )}
    </Dropdown>
  );
};

export default HeaderDropdownKD;
